import React, { useCallback, useEffect, useState } from "react";
import { studyEntriesDatePickerReducer } from "./StudyEntriesDatepicker.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import DateSelect from "../../../components/ui-library/DateAndTime/Date/DateSelect";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "./StudyEntriesDatepicker.store.js";
import { useTranslation } from "react-i18next";
import { isRtl } from "../../../i18n/helpers";

const DatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -75px;
  padding-bottom: 50px;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const StudyEntriesDatepicker = (props) => {
  const {
    study,
    lastEntryDate,
    selectedDate,
    fetchLastEntryDate,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    update,
    onUpdate,
    resetState,
  } = props;

  const { t } = useTranslation();

  const [showErrorDate, setShowErrorDate] = useState(false);
  const [isValidDate, setIsValidDate] = useState(true);

  const errorHandling = {
    showErrorDate: showErrorDate,
    setShowErrorDate: setShowErrorDate,
    isValidDate: isValidDate,
    setIsValidDate: setIsValidDate,
  };

  const rangeDateOptions = [
    {
      title: t("appText.today"),
      isSingleDay: true,
      daysFromToday: 0,
    },
    {
      title: t("appText.yesterday"),
      isSingleDay: true,
      daysFromToday: 1,
    },
    {
      title: t("appText.last7days"),
      isSingleDay: false,
      daysFromToday: 7,
    },
  ];

  const updateDates = useCallback(() => {
    fetchLastEntryDate();
  }, [fetchLastEntryDate]);

  useEffect(() => {
    if (!lastEntryDate && !selectedDate && study) {
      updateDates();
    }
  }, [lastEntryDate, selectedDate, study, updateDates]);

  useEffect(() => {
    if (update) {
      onUpdate();
    }
  }, [onUpdate, update, updateDates]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const onCalendarClose = () => {
    if (startDate && !endDate) {
      setEndDate(startDate);
    }
  };

  return (
    <DatePickerWrapper>
      <DateSelect
        data-testid="sted"
        eventDate={startDate}
        setEventDate={setStartDate}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        errorHandling={errorHandling}
        monthsShown={2}
        selectsRange={true}
        displayDateOptions={true}
        rangeDateOptions={rangeDateOptions}
        displayTitle={false}
        maxDate={new Date()}
        onCalendarClose={onCalendarClose}
        isRtl={isRtl()}
      />
    </DatePickerWrapper>
  );
};

export default dynamic(
  "studyEntriesDatePickerReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(studyEntriesDatePickerReducer)
)(connect(mapStateToProps, mapDispatchToProps)(StudyEntriesDatepicker));
